import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientSickCerts = (patientId, { page = 1, rows = 10 } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["patientSickCerts", tenantVal, patientId, page, rows],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientsickcert/getbypatientid/${patientId}`,
        { params: { page, rows } }
      );

      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
